import { PropsWithChildren } from 'react';

// project imports
import { ConfigProvider } from '@/theme/ConfigContext';
import ThemeCustomization from '@/theme/theme-customization';

// ==============================|| APP THEME PROVIDER ||============================== //

// Composes the theme config store (ConfigProvider) with the MUI theme builder
// (ThemeCustomization). Exposed as a single entry point so the render tree only
// needs to mount <AppThemeProvider>.
export function AppThemeProvider({ children }: PropsWithChildren) {
  return (
    <ConfigProvider>
      <ThemeCustomization>{children}</ThemeCustomization>
    </ConfigProvider>
  );
}
